import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { SpeakerEntry } from '../../../../../interfaces/pagebuilder';
import { VyImage } from '../../../../common/VyImage';
import MbwSpeakerButton from './MBWSpeakerButton';

interface MbwSpeakerItemProps {
  speaker: SpeakerEntry;
  showDetails?: boolean;
  onSelect?: (speaker: SpeakerEntry) => void;
  showImageHolder?: boolean;
  iconColor?: string;
}
const MbwSpeakerItem = ({ speaker, showDetails = false, onSelect, showImageHolder = true, iconColor }: MbwSpeakerItemProps) => {
  return (
    <div className="flex w-full p-4">
      <div className="flex flex-col w-full sm:flex-row">
        {showImageHolder && <div className="w-16 h-full md:w-24">{speaker.image && <VyImage id={speaker.image} />}</div>}
        <div className={`flex flex-col font-bold p-2 pl-0 ${showImageHolder ? 'sm:pl-4' : ''} flex-1`}>
          <span className="text-sm md:text-lg">{speaker.name}</span>
          <p className="text-sm font-thin sm:font-bold" dangerouslySetInnerHTML={{ __html: speaker.position }}></p>
          {showDetails && (
            <p
              className="mt-4 ml-4"
              dangerouslySetInnerHTML={{
                __html: speaker.description,
              }}></p>
          )}
        </div>
      </div>
      {!showDetails && speaker.description && (
        <div className="flex items-center justify-center">
          <MbwSpeakerButton onClick={() => onSelect?.(speaker)}>
            <div className="p-2">
              <FontAwesomeIcon size="1x" icon={faPlus} color={iconColor ?? 'white'} />
            </div>
          </MbwSpeakerButton>
        </div>
      )}
    </div>
  );
};

export default MbwSpeakerItem;
